module.exports = __webpack_public_path__ + "img/2@2x.0f03f439.png";